import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cubique',
  templateUrl: './cubique.component.html',
  styleUrls: ['./cubique.component.scss']
})
export class CubiqueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
